import type { ReactNode } from "react";

/** Lightweight, consistent line icons for the ONE CORE creator shell (no icon-CDN dependency). */
export type CreatorIconName =
  | "home" | "core" | "add" | "folder" | "templates" | "resources"
  | "chat" | "voice" | "image" | "video" | "music" | "agents"
  | "knowledge" | "tools" | "account" | "menu" | "search"
  | "close" | "billing" | "settings" | "academy" | "community"
  | "library" | "chevron";

const glyphs: Record<CreatorIconName, ReactNode> = {
  home: <><path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1z" /></>,
  core: <><path d="M12 2 9 9 2 12l7 3 3 7 3-7 7-3-7-3z" /><circle cx="12" cy="12" r="2" /></>,
  add: <><rect x="3" y="3" width="18" height="18" rx="3" /><path d="M12 7v10M7 12h10" /></>,
  folder: <><path d="M3 6h7l2 3h9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><path d="M3 9h18" /></>,
  templates: <><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 8h8M8 12h8M8 16h5" /></>,
  resources: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M8 3v4m8-4v4M3 10h18" /></>,
  chat: <><path d="M21 11a8 8 0 0 1-8 8H8l-5 3v-6a8 8 0 1 1 18-5Z" /></>,
  voice: <><rect x="9" y="2" width="6" height="13" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v4M8 22h8" /></>,
  image: <><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="8" cy="9" r="1.5" /><path d="m3 17 6-5 4 3 3-2 5 4" /></>,
  video: <><rect x="2" y="5" width="15" height="14" rx="2" /><path d="m17 10 5-4v12l-5-4" /><path d="m9 9 4 3-4 3z" /></>,
  music: <><path d="M9 19V5l12-2v14" /><ellipse cx="6.5" cy="19.5" rx="2.5" ry="1.5" /><ellipse cx="18.5" cy="17.5" rx="2.5" ry="1.5" /></>,
  agents: <><circle cx="12" cy="6" r="3" /><circle cx="5" cy="18" r="2" /><circle cx="19" cy="18" r="2" /><path d="M12 9v4M12 13l-7 3m7-3 7 3" /></>,
  knowledge: <><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 8h8M8 12h8M8 16h8" /></>,
  tools: <><path d="M13 3a5 5 0 0 0-5 6l-5 5a3 3 0 0 0 4 4l5-5a5 5 0 0 0 6-7l-4 4-3-3z" /></>,
  account: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
  menu: <><path d="M4 6h16M4 12h16M4 18h16" /></>,
  search: <><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 5 5" /></>,
  close: <><path d="M5 5 19 19M19 5 5 19" /></>,
  billing: <><rect x="3" y="5" width="18" height="15" rx="2" /><path d="M3 10h18M7 16h4" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M12 2v3m0 14v3M2 12h3m14 0h3M5 5l2.2 2.2m9.6 9.6L19 19M19 5l-2.2 2.2m-9.6 9.6L5 19" /></>,
  academy: <><path d="m2 9 10-5 10 5-10 5zM6 12v5c4 3 8 3 12 0v-5M22 9v7" /></>,
  community: <><path d="M20.5 8a4.5 4.5 0 0 1-8.5 2 4.5 4.5 0 1 1-8.5-2C3.5 4 8 3 12 8c4-5 8.5-4 8.5 0Z" /><path d="M12 21s-6-4-8-7" /></>,
  library: <><path d="M4 4h15a1 1 0 0 1 1 1v16H5a2 2 0 0 1-1-4z" /><path d="M4 17h16M8 8h8" /></>,
  chevron: <><path d="m7 10 5 5 5-5" /></>
};

export function CreatorIcon({ name, size = 19 }: { name: CreatorIconName; size?: number }) {
  return <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
    width={size} height={size} focusable="false">{glyphs[name]}</svg>;
}
